class deductionListCtrl {
    constructor($scope, $uibModal, logger, httpRequest, $state, initSortService) {
        $scope.batchDropdownConfig = {
            btnText: '批量操作',
            options: [{
                text: '抵扣属期',
                hasPermit: 'dedu_set',
                handler() {
                    $scope.batchSetDate()
                },
            }, {
                text: '推送凭证',
                hasPermit: 'push_vouchers',
                handler() {
                    $scope.batchPushVouchers()
                },
            }],
        }
        $scope.isFoldBatchOperation = true
        $scope.param = {
            pageNum: 1,
            pageSize: 10,
            param: {
                amountEnd: '',
                amountStart: '',
                deductionDate: '',
                expenseDate: '',
                expenseId: '',
                userName: '',
            },
        }
        $scope.reset = function reset() {
            $scope.param.param = {
                amountEnd: '',
                amountStart: '',
                deductionDate: '',
                expenseDate: '',
                expenseId: '',
                userName: '',
            }
        }
        // 所属期日期控件设置
        $scope.datePickerConfig = {
            format: 'yyyymm',
            startView: 'year',
            minView: 'year',
            endDate: new Date(),
        }
        // 字典字段
        httpRequest.get_dictByTypeArr(['expense_work_status', 'expense_voucher_push_status']).then((res) => {
            $scope.dictionary = res.data.value
        })
        // 初始化查询和表格控件实例
        $scope.customizedConfig = {
            version: 1.04,
            queryConfig: [
                {
                    label: '报销单号',
                    selected: true,
                    default: true,
                }, {
                    label: '姓名',
                    selected: true,
                    default: true,
                }, {
                    label: '报销日期',
                    selected: true,
                    default: true,
                }, {
                    label: '报销金额',
                    selected: true,
                    default: true,
                }, {
                    label: '抵扣属期',
                    selected: false,
                    default: false,

                }],
            table: [
                {
                    label: '报销单号',
                    selected: true,
                    default: true,
                }, {
                    label: '姓名',
                    selected: true,
                    default: true,
                }, {
                    label: '部门',
                    selected: true,
                    default: true,
                }, {
                    label: '报销类型',
                    selected: true,
                    default: true,
                }, {
                    label: '报销日期',
                    selected: true,
                    default: true,
                }, {
                    label: '报销金额',
                    selected: true,
                    default: true,
                }, {
                    label: '发票张数',
                    selected: true,
                    default: true,
                }, {
                    label: '抵扣税额',
                    selected: false,
                    default: false,
                }, {
                    label: '转出税额',
                    selected: false,
                    default: false,
                }, {
                    label: '抵扣属期',
                    selected: true,
                    default: true,
                }, {
                    label: '凭证分录',
                    selected: true,
                    default: true,
                }, {
                    label: '推送状态',
                    selected: true,
                    default: true,
                }],
        }
        $scope.$on('$stateChangeStart', (e, toState) => {
            if (toState.name.indexOf('input/reimburseManage/deduction') == -1) {
                sessionStorage.removeItem('deductionListParam')
            }
        })
        // 表格下拉框配置
        $scope.tableDropdownConfig = [{
                label: '详情',
                handler(item) {
                    $state.go('input.reimburseManage.deduction.detail', {
                        expenseId: item.expenseId
                    })
                },
                showWhile(item, hasPermit) {
                    return hasPermit('dedu_detail')
                },
            },
            {
                label: '编辑分录',
                handler(item) {
                    $scope.vouchersModal(2, item)
                },
                showWhile(item, hasPermit) {
                    return hasPermit('edit_vouchers') && item.pushStatus !== '1' && item.pushStatus !== '2'
                }
            },
            {
                label: '推送凭证',
                handler(item) {
                    pushVouchers([item])
                },
                showWhile(item, hasPermit) {
                    return hasPermit('push_vouchers') && item.pushStatus !== '1' && item.pushStatus !== '2'
                }
            },
        ]
        // 查询报销类型
        $scope.reimburseType = []
        httpRequest.get_getIvatBxPzDTOList(false).then((res) => {
            const allType = res.data.value
            for (let i = 0; i < allType.length; i++) {
                const obj = {
                    enumName: allType[i].expenseName,
                    enumCode: allType[i].confId,
                }
                $scope.reimburseType.push(obj)
            }
        })
        // 批量提交
        $scope.batchSetDate = function () {
            if (!$scope.selectedRows.length) {
                logger.logError('请选择报销单据')
                return
            }
            const expenseIds = []
            let deductFlag = false
            $scope.selectedRows.forEach((item) => {
                expenseIds.push(item.expenseId)
                deductFlag = (item.deductionAmt == 0 && item.turnOutAmt == 0)
            })
            if (!deductFlag) {
                $uibModal.open({
                    templateUrl: 'daduSetdate.html',
                    controller: ['$scope', '$uibModalInstance', function ctrl(scope, uibModalInstance) {
                        // 所属期日期控件设置
                        const now = new Date()
                        const curmonth = now.getMonth() + 1
                        const curmonthStr = (curmonth) < 9 ? `0${curmonth}` : curmonth

                        scope.datePickerConfig = {
                            format: 'yyyymm',
                            startView: 'year',
                            minView: 'year',
                            // endDate: now
                        }
                        scope.newDeductionDate = `${now.getFullYear()}${curmonthStr}`
                        scope.cancel = function cancel() {
                            uibModalInstance.close()
                        }
                        scope.ok = function ok() {
                            if (scope.newDeductionDate) {
                                uibModalInstance.close(scope.newDeductionDate)
                            } else {
                                logger.logError('请选择抵扣属期')
                            }
                        }
                    }],
                    openedClass: 'mod-modal mod-modal-md deduciton-modal',
                    backdrop: 'static',
                }).result.then((result) => {
                    if (result) {
                        httpRequest.get_batchSettingDeductionDate({
                            expenseIds,
                            period: result,
                        }).then(() => {
                            logger.logSuccess('设置成功')
                            $scope.queryListInfo()
                        })
                    }
                })
            } else {
                logger.logError('只能对抵扣税额不为0或进项转出不为0的单据设置抵扣属期')
            }
        }
        // 报销报告
        $scope.deductReport = function () {
            $state.go('input.reimburseManage.deduction.report')
        }
        // 表头排序
        $scope.orderMap = initSortService('deductionListParam')
        $scope.selectedHandle = function () {
            $scope.param.orderMap = {}
            if ($scope.orderMap.sortKey) $scope.param.orderMap[$scope.orderMap.sortKey] = $scope.orderMap.sortVal
            sessionStorage.setItem('deductionListParam', JSON.stringify($scope.param))
            $scope.queryListInfo()
        }
        // 查询列表
        $scope.queryListInfo = function () {
            $scope.param = sessionStorage.deductionListParam ? JSON.parse(sessionStorage.deductionListParam) : $scope.param
            httpRequest.post_qryDeductionListOfPage($scope.param).then((res) => {
                $scope.listData = res.data.value.list
                // 获取后台分页数据 回写分页组件
                $scope.totalItems = res.data.value.total
                $scope.param.pageNum = res.data.value.pageNum
                // 查询之后清空已经选择的数据
                $scope.selectedRows = []
            })
        }
        $scope.searchList = function () {
            sessionStorage.setItem('deductionListParam', JSON.stringify($scope.param))
            $scope.queryListInfo()
        }
        $scope.queryListInfo()
        // 分页
        $scope.pageChanged = function () { // 点击页码发起查询
            sessionStorage.setItem('deductionListParam', JSON.stringify(
                {
                    orderMap: $scope.param.orderMap,
                    pageNum: $scope.param.pageNum,
                    pageSize: $scope.param.pageSize,
                    param: sessionStorage.deductionListParam ? JSON.parse(sessionStorage.deductionListParam).param : {
                        amountEnd: '',
                        amountStart: '',
                        deductionDate: '',
                        expenseDate: '',
                        expenseId: '',
                        userName: '',
                    },
                },
            ))
            $scope.queryListInfo()
        }
        $scope.totalItems = 0 // 组件初始化设置总页数

        $scope.ceshipdf = function () {
            $state.go('input.reimburseManage.deduction.testpdf')
        }
        // 推送凭证
        function pushVouchers(list) {
            if (!list || list.length === 0) {
                logger.logError('请先选择数据！')
                return
            }
            let hasPush = false,
                ids = []
            const tip = list.length > 1 ? '已选数据中存在已推送或推送中的凭证，请重新选择！' : '凭证已推送或正在推送，请勿重复请求！'
            list.forEach((item) => {
                if (item.pushStatus === '1' || item.pushStatus === '2') {
                    hasPush = true
                    return
                }
                ids.push(item.expenseId)
            })
            if (hasPush) {
                logger.logError(tip)
                return
            }
            httpRequest.post_pushExpenseVoucher(ids).then((res) => {
                logger.logSuccess('操作成功')
            }).finally(() => {
                $scope.queryListInfo()
            })
        }
        $scope.batchPushVouchers = () => {
            pushVouchers($scope.selectedRows)
        }
        $scope.vouchersModal = (type, item) => {
            // type 1 查看 2 编辑
            const loadingIndex = layer.msg('加载中...', {
                time: 0,
                skin: 'layer-loading-self',
                icon: 16,
                shade: 0.5,
            })
            httpRequest.get_getExpenseVoucher(item.expenseId).then((res) => {
                const className = type === 1 ? 'mod-modal-md' : 'mod-modal-lg'
                $uibModal.open({
                    templateUrl: 'vouchersEntry.html',
                    openedClass: `mod-modal ${className} modal-dedu-vouchers`,
                    animation: true,
                    resolve: {
                        items1() {
                            return {
                                type,
                                item,
                                list: res.data.value
                            }
                        },
                    },
                    controller: ['$scope', '$uibModalInstance', 'httpRequest', 'items1', ($scope, $uibModalInstance, httpRequest, items1) => {
                        $scope.modalData = items1
                        $scope.list = items1.list
                        // setInitAcctObj($scope.list)
                        $scope.select2Config = {
                            data: {},
                            placeholder: '请选择'
                        }
                        $scope.isSubmit = false
                        $scope.drCrs = [{
                            label: '借',
                            value: 'dr'
                        }, {
                            label: '贷',
                            value: 'cr'
                        }]
                        getAccts()
                        $scope.up = (item, index) => {
                            move($scope.list, index, item, -1)
                        }
                        $scope.down = (item, index) => {
                            move($scope.list, index, item, 1)
                        }

                        $scope.delete = (index) => {
                            $scope.list.splice(index, 1)
                        }
                        $scope.add = () => {
                            $scope.list.push({
                                drCr: '',
                                acctNo: '',
                                acctName: '',
                                amount: null,
                                expenseId: items1.item.expenseId
                            })
                        }
                        $scope.ok = () => {
                            if (!checkList($scope.list)) return
                            $scope.isSubmit = true
                            httpRequest.post_updateExpenseVoucher($scope.list).then((res) => {
                                logger.logSuccess('保存成功')
                                $uibModalInstance.close()
                            }).finally(() => {
                                $scope.isSubmit = false
                            })
                        }
                        $scope.cancel = () => {
                            $uibModalInstance.dismiss()
                        }

                        function checkList(list) {
                            if (!list || list.length === 0) {
                                logger.logError('分录不能为空，至少有一个“借方”及一个“贷方”！')
                                return false
                            }
                            let hasDr = false,
                                hasCr = false,
                                hasBlank = false,
                                drAmount = 0,
                                crAmount = 0
                            list.forEach((item) => {
                                item.acctName = item.acctObj ? item.acctObj.swkjkmmc : ''
                                if (item.drCr === 'dr') hasDr = true
                                if (item.drCr === 'cr') hasCr = true
                                if (!item.drCr || !item.acctNo || (!item.amount && item !== 0)) hasBlank = true
                                if (item.drCr === 'dr' && item.amount) drAmount += item.amount
                                if (item.drCr === 'cr' && item.amount) crAmount += item.amount
                            })
                            if (hasBlank) {
                                logger.logError('所有借贷方、科目、金额项都必填！')
                                return false
                            }
                            if (!hasDr || !hasCr) {
                                logger.logError('至少有一个“借方”及一个“贷方”！')
                                return false
                            }
                            if (list[0].drCr !== 'dr') {
                                logger.logError('第一行必须为“借方”！')
                                return false
                            }
                            if (list[list.length - 1].drCr !== 'cr') {
                                logger.logError('最后一行必须为“贷方”！')
                                return false
                            }
                            if (drAmount !== crAmount || drAmount != items1.item.amount) {
                                logger.logError('借方的“合计”金额必须等于贷方的“合计”金额，且等于报销单的“报销金额”！')
                                return false
                            }
                            return true
                        }

                        function move(list, index, item, d) {
                            if (index === 0 && d < 0 || index === $scope.list.length - 1 && d > 0) return
                            list.splice(index, 1)
                            list.splice(index + d, 0, item)
                        }

                        function getAccts() {
                            let param = {
                                pageNum: 1,
                                pageSize: 10000,
                                param: {
                                    accessToken: localStorage.id_token,
                                    swkjkmDmAndSwkjkmmc: '',
                                }
                            }
                            httpRequest.post_getSbSwkjkmDmList(param).then((res) => {
                                let arr = res.data.value.list
                                let has2221 = false
                                arr.forEach((i) => {
                                    if (i.swkjkmDm === '2221') {
                                        has2221 = true
                                        i.swkjkmmc = '应交税费-应交增值税（进项）'
                                    }
                                })
                                if (!has2221) {
                                    arr.push({
                                        swkjkmDm: '2221',
                                        swkjkmmc: '应交税费-应交增值税（进项）'
                                    })
                                }
                                let accts = toSelect2data(arr, 'swkjkmDm', 'swkjkmmc')
                                $scope.select2Config = {
                                    data: accts,
                                    placeholder: '请选择',
                                }
                                setInitAcctObj($scope.list)

                            })
                        }
                        // 科目下拉框初始值
                        function setInitAcctObj(list) {
                            list.forEach((i) => {
                                i.acctObj = {
                                    swkjkmDm: i.acctNo,
                                    swkjkmmc: i.acctName,
                                    id: i.acctNo,
                                    text: `${i.acctNo}/${i.acctName}`,
                                }
                            })
                        }

                        function toSelect2data(list, idfield, textfield) {
                            const result = []
                            for (const a in list) {
                                const tempdata = {
                                    id: '',
                                    text: ''
                                }
                                $.extend(tempdata, list[a])
                                tempdata.id = list[a][idfield]
                                tempdata.text = list[a][idfield] + '/' + list[a][textfield]
                                result.push(tempdata)
                            }
                            return result
                        }
                    }],
                }).result.then(() => {
                    $scope.queryListInfo()
                }, () => {})
            }).finally(() => {
                layer.close(loadingIndex)
            })
        }
    }
}

deductionListCtrl.$inject = ['$scope', '$uibModal', 'logger', 'httpRequest', '$state', 'initSortService']
export default deductionListCtrl



// WEBPACK FOOTER //
// ./src/app/input/reimburseManage/deduction/deductionListCtrl.js